export default "__VITE_ASSET__DEN8BcUq__"